import * as React from 'react';
import { useNavigate } from 'react-router';

import { Button } from '@independent-software/typeui/controls/Button';
import { Icon } from '@independent-software/typeui/controls/Icon';

import { AuthContext } from '../../AuthContext';
import { Container, Content, BottomBar } from '../../modules';
import { Station } from '../../resource/';
import { ListStations } from './ListStations';
import { Gate } from '../../controls/Gate';
import { FilterContext } from '../../FilterContext';

const StationList = () => {
  const auth = React.useContext(AuthContext);
  const filter = React.useContext(FilterContext);
  const navigate = useNavigate();

  // Go to add station view.
  const handleAdd = () => {
    navigate('/stations/add');
  }  

  // Go to view station view.
  const handleClick = (item: Station) => {
    navigate(`/stations/${item.id}`);
  }  

  return (
    <Container>
      <Content>
        <ListStations auth={auth} filter={filter} name="stations" onClick={handleClick}/>
      </Content>
      <BottomBar>
        <Gate right='can_edit_stations'>
          <Button primary onClick={handleAdd}><Icon name="plus"/> Add station</Button>
        </Gate>
      </BottomBar>
    </Container>
  );
}

export { StationList }
